module.exports = __webpack_public_path__ + "img/Colorize04.ee1deafd.png";